<template>
  <SectionView class="diet" title="AI 调养建议" >
    <!-- 不耐受食物部分 -->
    <div class="life-title">近期饮食建议</div>

    <template v-if="useless && useless.length > 0">
      <div class="food-section">
        <div class="section-header">
          <span class="count">{{useless.length}}</span>
          <span class="title">种不推荐食材</span>
          <span class="subtitle">建议减少摄入</span>
        </div>
        <div class="food-grid">
          <div v-for="(item, index) in useless" :key="'useless-'+index" class="food-item">
            <img :src="item.report_food_url" alt="食物图片"/>
            <div>{{item.report_food_name}}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="food-section">
        <div class="section-header">
          <span class="count">0</span>
          <span class="title">种不推荐食材</span>
          <span class="subtitle">建议减少摄入</span>
        </div>
        <div class="empty-message">未见不推荐食材</div>
      </div>
    </template>

    <!-- 适宜食物部分 -->
    <template v-if="useful && useful.length > 0">
      <div class="food-section useful-section">
        <div class="section-header">
          <span class="count">{{useful.length}}</span>
          <span class="title">种推荐食材</span>
          <span class="subtitle">推荐补充食物</span>
        </div>
        <div class="food-grid">
          <div v-for="(item, index) in useful" :key="'useful-'+index" class="food-item">
            <img :src="item.report_food_url" alt="食物图片"/>
            <div>{{item.report_food_name}}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="suggestionData &&suggestionData.length">
      <div v-if="!suggestionCollapsed">
        <div class="life-title">生活方式改善建议</div>
        <div class="improve-content" v-for="(item,index) in suggestionData" :key="index">
          <div class="improve-item">
            <!-- <img class="improve-icon" src="/src/assets/motion.png" /> -->
            <img class="improve-icon" alt="建议"  :src="require(`@/assets/${item.type===1?'motion':item.type===2?'drinking':'sleep'}.png`)"/>
            <div class="improve-section">
              <div class="improve-title">{{item.topic}}</div>
              <div class="improve-text">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse-button" @click="toggleSuggestionCollapse">
        <span>{{ suggestionCollapsed ? "展开更多" : "收起" }}</span>
        <img
          :src="
            require(`@/assets/AIUnscramble/${
              suggestionCollapsed ? 'Down.png' : 'up.png'
            }`)
          "
          class="collapse-arrow-icon"
          alt="展开/收起"
        />
      </div>
    </template>

    <!-- 弹窗 -->
    <dialog-view title="饮食建议" v-model="dialog">
      每日进行食物适应性测试，按照每日建议饮食定时定量，全面均衡，严禁食用不耐受食物。
    </dialog-view>
    
    <!-- 一键定制解决方案按钮 -->
    <div class="solution-section">
      <div class="solution-btn" @click="openAiQuestion">一键定制解决方案</div>
      <div class="solution-divider"></div>
    </div>
    
    <!-- 抽屉弹窗 -->
    <div class="dialog-wrapper" v-if="showDialog" @touchmove.prevent="$event.preventDefault();"
      @wheel.prevent="$event.preventDefault();">
      <div class="dialog">
        <div class="dialog-list" v-if="editing === 'list'">
          <div class="close-btn" @click="closeHandle">
            <div class="close-icon"></div>
          </div>
          <div class="title">核对信息 <span class="tip">| 核对一下，确保营养方案的精准有效</span></div>

          <div class="info-item" @click="editField('name')">
            <span>用户名：</span>
            <div class="info-right">
              <span class="user-name">{{ userInfo.name }}</span>
              <img class="user-icon" :src="require('@/assets/进入@2x.png')" alt="修改">
            </div>
          </div>

          <div class="info-item" @click="editField('age')">
            <span>年龄：</span>
            <div class="info-right">
              <span class="user-name">{{ userInfo.age }}</span>
              <img class="user-icon" :src="require('@/assets/进入@2x.png')" alt="修改">
            </div>
          </div>

          <div class="info-item" @click="editField('gender')">
            <span>性别：</span>
            <div class="info-right">
              <span class="user-name">{{ userInfo.gender === '1' ? '男' : '女' }}</span>
              <img class="user-icon" :src="require('@/assets/进入@2x.png')" alt="修改">
            </div>
          </div>

          <div class="info-item" @click="editField('user_height')">
            <span>身高：</span>
            <div class="info-right">
              <span class="user-name">{{ userInfo.user_height }} cm</span>
              <img class="user-icon" :src="require('@/assets/进入@2x.png')" alt="修改">
            </div>
          </div>

          <div class="info-item" @click="editField('user_weight')">
            <span>体重：</span>
            <div class="info-right">
              <span class="user-name">{{ userInfo.user_weight }} kg</span>
              <img class="user-icon" :src="require('@/assets/进入@2x.png')" alt="修改">
            </div>
          </div>

          <button class="confirm-btn" @click="confirm">确认</button>

        </div>
        <div class="emit-back" v-if="editing !== 'list'">
          <img class="back-icon" @click="backList" :src="require('@/assets/back.png')" alt="返回">
          <div class="emit-title" v-if="editing === 'name'">编辑用户名</div>
          <div class="emit-title" v-if="editing === 'age'">编辑年龄</div>
          <div class="emit-title" v-if="editing === 'gender'">编辑性别</div>
          <div class="emit-title" v-if="editing === 'user_height'">编辑身高</div>
          <div class="emit-title" v-if="editing === 'user_weight'">编辑体重</div>
        </div>
        <!-- 编辑弹窗 -->
        <div class="edit-modal">
          <div class="edit-content" v-if="editing === 'name'">
            <div class="edit-place">请输入用户名</div>
            <input ref="nameInput" class="edit-name" v-model="userInfoCopy.name" placeholder="" />
          </div>
          <!-- 年龄选择器 -->
          <div class="edit-content" v-if="editing === 'age'" @touchmove.stop @wheel.stop>
            <van-datetime-picker ref="birdayRef" :value="new Date(userInfoCopy.birthday)" type="date"
              :min-date="new Date('1925-01-01')" :max-date="new Date()" :show-toolbar="false" @change="ageChange" />
          </div>

          <!-- 身高选择器 -->
          <div class="edit-content" v-if="editing === 'user_height'" @touchmove.stop @wheel.stop>
            <van-picker ref="heightPicker" :columns="heightOptions" @change="heightChange"
              :default-index="heightIndex" />
          </div>

          <!-- 体重选择器 -->
          <div class="edit-content" v-if="editing === 'user_weight'" @touchmove.stop @wheel.stop>
            <van-picker ref="weightPicker" :columns="weightOptions" @change="weightChange"
              :default-index="weightIndex" />
          </div>
          <!-- 性别选择 -->
          <div class="edit-content" v-if="editing === 'gender'">
            <van-picker ref="genderPickerRef" :columns="genderOptions" @change="genderChange"
              :default-index="genderIndex" />

          </div>

          <button v-if="editing !== 'list'" class="edit-btn" @click="saveEdit">确认</button>
        </div>
      </div>
    </div>
    
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";
  import DialogView from "./DialogView";
  import { Toast } from 'vant';

  /**
   * 饮食建议卡片
   */
  export default {
    name: "DietCard",
    components: {DialogView, SectionView},

    props: {
      // 耐受食物
      useful: {
        type: Array,
        require: false
      },
      // 不耐受食物
      useless: {
        type: Array,
        require: false
      },
      suggestionData: {
        type: Array,
        require: false
      },
      userData: {
        type: Object,
        require: false
      },
      packageNo: {
        type: String,
        require: false
      }
    },

    data() {
      return {
        dialog: false,
        isCollapsed:false,
        showDialog: false,
        suggestionCollapsed: true,
        userInfo: {
          name: "",
          age: 0,
          gender: "1",
          user_height: '0',
          user_weight: '0',
          birthday: ''
        },
        userInfoCopy: {
          name: "",
          age: 0,
          gender: "1",
          user_height: '0',
          user_weight: '0',
          birthday: ''
        },
        editing: 'list',
        heightOptions: [],
        weightOptions: [],
        heightIndex: 0,
        weightIndex: 0,
        genderIndex: 0,
        genderOptions: [{ text: '男', value: '1' }, { text: '女', value: '2' }]
      }
    },
    methods:{
      toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
      },
      toggleSuggestionCollapse() {
        this.suggestionCollapsed = !this.suggestionCollapsed;
      },
      openAiQuestion() {
        this.showDialog = true
        this.$store.commit("SetOpenAiChat", { openAiChat: true });
      },
      closeHandle() {
        this.showDialog = false
        this.$store.commit("SetOpenAiChat", { openAiChat: false });
      },
      editField(field) {
        this.editing = field;
      },
      calculateAge(data) {
        const today = new Date();
        const birthDate = new Date(data)
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      saveEdit() {
        switch (this.editing) {
          case 'name':
            if (this.userInfoCopy.name === '') {
              Toast('请输入用户名')
              return
            } else {
              this.userInfo.name = this.userInfoCopy.name;
            }
            break
          case 'age':
            this.userInfo.birthday = this.userInfoCopy.birthday;
            this.userInfo.age = this.calculateAge(this.userInfoCopy.birthday)
            break;
          case 'gender':
            this.userInfo.gender = this.userInfoCopy.gender
            break;
          case 'user_height':
            this.userInfo.user_height = this.userInfoCopy.user_height;
            break;
          case 'user_weight':
            this.userInfo.user_weight = this.userInfoCopy.user_weight
            break;
        }
        this.editing = 'list'
      },
      backList() {
        switch (this.editing) {
          case 'name':
            this.userInfoCopy.name = this.userInfo.name
            break
          case 'age':
            this.userInfoCopy.birthday = this.userInfo.birthday;
            break;
          case 'gender':
            this.userInfoCopy.gender = this.userInfo.gender
            break;
          case 'user_height':
            this.userInfoCopy.user_height = this.userInfo.user_height;
            break;
          case 'user_weight':
            this.userInfoCopy.user_weight = this.userInfo.user_weight;
            break;
        }
        this.editing = 'list'
      },
      heightChange(picker, value, index) {
        this.userInfoCopy.user_height = value;
        this.heightIndex = index
      },
      weightChange(picker, value, index) {
        this.userInfoCopy.user_weight = value;
        this.weightIndex = index
      },
      genderChange(picker, value, index) {
        this.userInfoCopy.gender = value.value;
        this.genderIndex = index
      },
      ageChange(value) {
        this.userInfoCopy.birthday = value.getValues().join('-');
      },
      confirm() {
        if (this.userInfo.name)
          this.$router.push({
            path: '/questionnaire',
            query: {
              user_Data: {
                name: this.userInfo.name,
                age: this.userInfo.age,
                birthday: this.userInfo.birthday,
                gender: this.userInfo.gender,
                user_height: this.userInfo.user_height,
                user_weight: this.userInfo.user_weight,
              }
            }
          })
        this.closeHandle()
      },
      getHeightOptions() {
        this.heightOptions = [];
        for (let i = 70; i <= 250; i++) {
          this.heightOptions.push(i);
        }
        this.heightIndex = this.heightOptions.findIndex(i => i === +this.userInfo.user_height);
      },
      getWeightOptions() {
        this.weightOptions = [];
        for (let i = 10; i <= 300; i++) {
          this.weightOptions.push(i);
        }
        this.weightIndex = this.weightOptions.findIndex(i => i === +this.userInfo.user_weight);
      }
    },
    mounted() {
      if (this.userData) {
        this.userInfo = {
          ...this.userData,
          user_weight: +this.userData.user_weight,
          user_height: +this.userData.user_height
        };
        this.userInfoCopy = JSON.parse(JSON.stringify(this.userInfo))
        this.genderIndex = this.userInfo.gender - 1
      }
      this.getHeightOptions();
      this.getWeightOptions();
    }
  }
</script>

<style lang="scss" scoped>
  .diet {
    padding:50px 30px 0;
    box-sizing: border-box;
    .food-section {
      margin-bottom: 15px;
      border-radius: 10px;
      // padding: 20px;
      
      &.useful-section {
        margin-top: 10px;
        margin-bottom: 40px;
        .section-header {
          .count {
            color: #003BBF;
          }
          
          .subtitle {
            color: #999;
          }
        }
      }
    }
    
    .section-header {
      margin-bottom: 20px;
      display: flex;
      align-items: baseline;
      
      .count {
        font-size: 36px;
        font-weight: bold;
        color: #FF5B4D;
        margin-right: 10px;
      }
      
      .title {
        font-size: 28px;
        font-weight: 500;
        color: #333;
        margin-right: 15px;
      }
      
      .subtitle {
        font-size: 24px;
        color: #999;
      }
    }
    
    .food-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
    }
    
    .food-item {
      width: 135px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
      margin-top: 20px;
      margin-left: 30px;
      
      img {
        width: 68px;
        height: 68px;
        object-fit: cover;
        margin-bottom: 12px;
      }
      
      div {
        font-weight: 400;
font-size: 20px;
color: #00133D;
line-height: 14px;
text-align: center;
font-style: normal;
text-transform: none;
      }
    }
    
    .empty-message {
      text-align: center;
      padding: 30px 0;
      color: #999;
      font-size: 28px;
    }

  }
  .collapse-button {
  text-align: center;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 5px 0;
  font-size: 28px;
}
.life-title{
  color:#2C324E;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 30px;
}
.improve-content{
  .improve-item{
    // width: 90%;
    // background: pink;
    display: flex;
    margin-bottom: 50px;
    .improve-icon{
      width: 70px;
      height: 70px;
      margin-right: 30px;
    }
    .improve-section{
      // flex:1;
      font-size: 28px;
      .improve-title{
        color: #2C324E;
        font-weight: bold;
        margin-bottom: 20px;

      }
      .improve-text{
        color: #495880;
      }
    }
  }
}

/* 一键定制解决方案按钮样式 */
.solution-section {
  margin-top: 50px;
  
  .solution-divider {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #CCCCCC;
    margin-top: 50px;
    margin-bottom: 40px;
  }
  
  .solution-btn {
    width: 100%;
    height: 90px;
    line-height: 90px;
    text-align: center;
    background-color: #003cbf;
    color: #ffffff;
    border: none;
    border-radius: 45px;
    font-size: 30px;
    font-weight: 500;
    margin-bottom: 50px;
    cursor: pointer;
  }
}

/* 抽屉弹窗样式 */
.dialog-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
}

.dialog {
  width: 100%;
  position: absolute;
  bottom: 0;
  border-radius: 30px 30px 0 0;
  background: #fff;
  box-sizing: border-box;
  padding: 30px;
}

.title {
  font-size: 36px;
  color: #111827;
  font-weight: bold;
  padding: 30px 0;
  // border-bottom: 1px solid #DBDBDB;
}

.tip {
  font-size: 26px;
  color: #808080;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 40px 20px 10px;
  border-bottom: 1px solid #eee;
  font-size: 28px;
  color: #4B5563;
}

.user-name {
  font-size: 32px;
  color: #3B4B67;
  vertical-align: top;
}

.user-icon {
  width: 40px;
  height: 40px;
}

.confirm-btn {
  width: 100%;
  height: 100px;
  border-radius: 95px;
  padding: 20px;
  background: #003CBF;
  color: #fff;
  border: none;
  margin: 100px 0 50px;
  font-size: 36px;
}

.emit-back {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 20px 0;
  // border-bottom: 1px solid #DBDBDB;
}

.back-icon {
  width: 46px;
  height: 46px;
}

.emit-title {
  flex: 1;
  text-align: center;
  font-size: 36px;
  vertical-align: top;
  display: inline-block;
  font-weight: bold;
}

.close-btn {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  z-index: 2;

  .close-icon {
    position: relative;
    width: 100%;
    height: 100%;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 40px;
      height: 4px;
      background-color: #999;
      top: 50%;
      left: 0;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

.edit-modal {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.edit-content {
  height: 70%;
}

.edit-place {
  font-size: 30px;
  color: #808080;
  padding: 50px 0 20px;
}

.edit-name {
  box-sizing: border-box;
  width: 100%;
  padding: 40px;
  border-radius: 20px;
  border: 1px solid #DBDBDB;
  text-align: center;
  font-size: 36px;
}

.edit-btn {
  width: 100%;
  height: 100px;
  border-radius: 90px;
  background: #003CBF;
  color: #fff;
  border: none;
  font-size: 36px;
  font-weight: 500;
  margin: 100px 0 60px;
}

::v-deep ul {
  display: block !important;
}
</style>